import React from 'react';
import useLabel from 'hooks/use-label';
import If from 'components/if-statement';
import ErrorMessage from 'components/error-message';
import {
  Container,
  LayoutContainer,
  SelectedIcon,
  UnSelectedIcon,
} from 'components/option/style';
import { Label } from 'components/typography';

import { OnChange } from 'utils/types/react';

interface OptionProps {
  // Value is used by from(withForm hoc)
  value?: boolean;
  inGroup?: boolean;
  label: string;
  errorMessage: string;
  onChange: OnChange;
  onClick: Function;
  withForm: boolean;
  invalid: boolean;
  isChecked: boolean;
  className?: string;
}

export function useOption<Props>(props): Props & OptionProps {
  const [isChecked, setChecked] = React.useState(props.value);

  React.useEffect(() => {
    setChecked(props.value);
  }, [props.value]);

  function onClick() {
    setChecked(!isChecked);

    props.onChange(!isChecked);
  }

  const { withForm, errorMessage, wasSubmitted } = props;

  return {
    ...props,
    onClick,
    isChecked,
    setChecked,
    errorMessage,
    invalid: withForm && errorMessage && wasSubmitted,
  };
}

export interface OptionComponentProps {}

function Option(props: OptionComponentProps) {
  const {
    onChange: _,
    value: __,
    inGroup,
    onClick,
    withForm,
    errorMessage,
    isChecked,
    invalid,
    className,
    ...rest
  } = useOption<OptionComponentProps>(props);

  const label = useLabel(rest.label);

  const Icon = isChecked ? SelectedIcon : UnSelectedIcon;

  return (
    <Container inGroup={inGroup} withForm={withForm} className={className}>
      <LayoutContainer onClick={onClick}>
        <Icon $invalid={invalid} />
        {label && <Label $invalid={invalid}>{label}</Label>}
      </LayoutContainer>
      <If condition={invalid && inGroup === false}>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </If>
    </Container>
  );
}

export default Option;
